import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation, Trans } from 'react-i18next'
import ModalImage from 'react-modal-image'
import Embed from 'react-tiny-oembed'

import Input from '../../../common/form/Input'
// import RichTextEditor from '../../../common/form/RichTextEditor/RichTextEditor'
import CategorySelect from './CategorySelect'
import ProgramSearchTags from './ProgramSearchTags'
import { ReactComponent as CameraIcon } from '../../../../assets/images/common/icons/programBuilder/camera-icon.svg'
import { ReactComponent as PlayVideoIcon } from '../../../../assets/images/common/icons/programBuilder/play-video-icon.svg'
import HeaderImageModal from './HeaderImageModal'
import PersonalizedVideoModal from './PersonalizedVideoModal'
import { setField } from '../../../../reducers/programBuilderReducer'

import './Marketing.scss'

const DESCRIPTION_MAX_LENGTH = 2500

const Marketing = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const errors = useSelector(state => state.programBuilder.errors)
  const description = useSelector(state => state.programBuilder.description)
  const headerImageUrl = useSelector(state => state.programBuilder.headerImageUrl)
  const personalizedVideoUrl = useSelector(state => state.programBuilder.personalizedVideoUrl)

  const [showHeaderImageModal, setShowHeaderImageModal] = useState(false)
  const [showPersonalizedVideoModal, setShowPersonalizedVideoModal] = useState(false)

  const handleInputChange = e => {
    const field = e.target.name
    const value = e.target.value

    dispatch(setField({ field, value }))
  }

  // const handleInputChange = value => {
  //   dispatch(setField({ field: 'description', value }))
  // }

  const removeHeaderImage = () => {
    dispatch(setField({ field: 'headerImage', value: 'remove' }))
    dispatch(setField({ field: 'headerImageUrl', value: '' }))
  }

  const removePersonalizedVideo = () => {
    dispatch(setField({ field: 'personalizedVideoUrl', value: '' }))
  }

  return (
    <section id='Marketing'>
      <p className='title'>{t('programs.builder.marketing.title')}</p>
      <p>
        {t('programs.builder.marketing.intro')}
      </p>
      <div className='row'>
        <div className='col-12 col-md-7 mb-4'>
          <div className='d-flex justify-content-between align-items-start'>
            <label htmlFor='headerImage' className='mb-2'>
              {t('programs.builder.marketing.headerImage')}
            </label>

            {headerImageUrl && (
              <span className='remove-media' aria-hidden='true' onClick={removeHeaderImage}>{t('common.action.remove')}</span>
            )}
          </div>

          {headerImageUrl ? (
            <div className='media-card-container'>
              <ModalImage
                small={headerImageUrl}
                large={headerImageUrl}
                className='header-image-preview'
                alt={t('programs.builder.marketing.headerImage')}
                hideDownload
                hideZoom
              />
            </div>
          ) : (
            <div
              className='d-flex flex-column justify-content-center align-items-center media-card-container'
              aria-hidden='true'
              onClick={() => setShowHeaderImageModal(true)}
            >
              <CameraIcon className='mb-3' />

              {t('programs.builder.marketing.addHeaderImage')}
            </div>
          )}
        </div>

        <div className='col-12 col-md-5 mb-4'>
          <div className='d-flex justify-content-between align-items-start'>
            <label htmlFor='personalizedVideo' className='mb-2'>
              {t('programs.builder.marketing.personalizedVideo')}
            </label>

            {personalizedVideoUrl && (
              <span className='remove-media' aria-hidden='true' onClick={removePersonalizedVideo}>{t('common.action.remove')}</span>
            )}
          </div>

          {personalizedVideoUrl ? (
            <div className='media-card-container'>
              <div className='link-video-preview'>
                <Embed
                  url={personalizedVideoUrl}
                  FallbackElement=' '
                  LoadingFallbackElement=' '
                />
              </div>
            </div>
          ) : (
            <div
              className='d-flex flex-column justify-content-center align-items-center media-card-container'
              aria-hidden='true'
              onClick={() => setShowPersonalizedVideoModal(true)}
            >
              <PlayVideoIcon className='mb-2'/>

              {t('programs.builder.marketing.addVideo')}
            </div>
          )}
        </div>

        <div className='col-12 mb-4'>
          <label htmlFor='description' className='mb-1'>
            {t('programs.builder.marketing.descriptionLabel')}
          </label>
          <div className='d-flex justify-content-between align-items-start'>
            <p className='description-details mb-2'>
              <Trans
                i18nKey='programs.builder.marketing.descriptionIdeas'
                components={{
                  link: (
                    // eslint-disable-next-line jsx-a11y/anchor-has-content
                    <a
                      href='https://docs.google.com/document/d/18xcqDWgh95Y60hU0fQU7hAT8rHsINwyYBgIgJqEaTEM/edit?usp=sharing'
                      className='description-examples-link'
                      target='_blank'
                    />
                  ),
                }}
              />
            </p>
            <p className='character-counter m-0'>
              {t('programs.builder.marketing.characterCount', { count: description.length, max: DESCRIPTION_MAX_LENGTH })}
            </p>
          </div>

          <Input
            name='description'
            type='textarea'
            onChange={handleInputChange}
            placeholder={t('programs.builder.marketing.descriptionPlaceholder')}
            value={description}
            error={errors.description}
            maxLength={DESCRIPTION_MAX_LENGTH}
            styles={{ inputContainer: { height: '220px' } }}
          />
          {/* <RichTextEditor
            value={description}
            onChange={handleInputChange}
            placeholder={t('programs.builder.marketing.descriptionPlaceholder')}
            error={errors.description}
          /> */}
        </div>

        <div className='col-12 mb-4'>
          <label htmlFor='tags' className='mb-1'>
            {t('programs.builder.marketing.categoriesLabel')}
          </label>
          <p className='tags-details mb-2'>
            {t('programs.builder.marketing.categoriesDetails')}
          </p>

          <CategorySelect />
        </div>

        <div className='col-12 mb-4'>
          <label htmlFor='tags' className='mb-1'>
            {t('programs.builder.marketing.searchTagsLabel')}
          </label>
          <p className='tags-details mb-2'>
            {t('programs.builder.marketing.searchTagsDetails')}
          </p>

          <ProgramSearchTags />
        </div>
      </div>

      <HeaderImageModal
        showModal={showHeaderImageModal}
        closeModal={() => { setShowHeaderImageModal(false) }}
      />

      <PersonalizedVideoModal
        showModal={showPersonalizedVideoModal}
        closeModal={() => { setShowPersonalizedVideoModal(false) }}
      />
    </section>
  )
}

export default Marketing
